import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";
import { forwardRef, type ReactNode } from "react";

const linkVariants = cva(
  "inline-block font-semibold transition duration-200 ease-in-out",
  {
    variants: {
      variant: {
        default: "text-primaryaccent hover:text-foreground",
        secondary: "text-foreground hover:text-primaryaccent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

type LinkProps = NextLinkProps<true> &
  VariantProps<typeof linkVariants> & {
    isExternal?: boolean;
    children?: ReactNode;
    className?: string;
  };

const GroqLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, className, isExternal, variant, ...props }: LinkProps, ref) => {
    return (
      <NextLink
        className={cn(linkVariants({ variant, className }))}
        target={isExternal ? "_blank" : undefined}
        ref={ref}
        {...props}
      >
        {children}
      </NextLink>
    );
  },
);

export default GroqLink;
